module.exports = __webpack_public_path__ + "img/hmc_logo.1e942929.png";